<template lang="pug">
div
    el-dialog.modal-detalhe-aptidao(
        :visible.sync='mostrarModal',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        fullscreen
    )
        .modal-detalhe-aptidao__lista
            .modal-detalhe-aptidao__lista__header
                h2.cursor-pointer(@click='fecharModal()')
                    i.el-icon-arrow-left.voltar
                    | {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.analiseAptidaoModalTitulo') }}

            .modal-detalhe-aptidao__lista__content(v-if='aptidaoSelecionada')
                .modal-detalhe-aptidao__territorio
                    h3 {{ aptidaoSelecionada.gleba.nomeTerritorio }}

                .modal-detalhe-aptidao__gleba-info
                    .modal-detalhe-aptidao__gleba-info__item
                        span.modal-detalhe-aptidao__gleba-info__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.gleba') }}:
                        span.modal-detalhe-aptidao__gleba-info__valor {{ aptidaoSelecionada.gleba.nome }}
                    .modal-detalhe-aptidao__gleba-info__item
                        span.modal-detalhe-aptidao__gleba-info__label {{ $t('mensagens.operacao.formularioGleba.areaHa') }}:
                        span.modal-detalhe-aptidao__gleba-info__valor {{ aptidaoSelecionada.gleba.areaHa }}

                el-collapse.modal-detalhe-aptidao__collapse(
                    v-model='collapseAtivo',
                    accordion,
                    @change='abrirCollapse'
                )
                    el-collapse-item(
                        v-for='item in itensAnalise',
                        :key='item.key',
                        :name='item.key'
                    )
                        template(slot='title')
                            .modal-detalhe-aptidao__collapse-title
                                i.modal-detalhe-aptidao__collapse-title__icone(
                                    :class='statusIcone(item.status)'
                                )
                                span {{ item.label }}

                        .modal-detalhe-aptidao__status-texto(
                            v-if='item.status',
                            :class='"modal-detalhe-aptidao__status-texto--" + item.status.toLowerCase()'
                        )
                            span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.resultadoConsolidado') }}:
                            span.modal-detalhe-aptidao__status-texto__valor {{ $t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.${item.status}`) }}

                        .modal-detalhe-aptidao__card(v-if='item.key === "historicoAgricola"')
                            .modal-detalhe-aptidao__card__item
                                span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.areaSemHistoricoAgricola') }}:
                                span.modal-detalhe-aptidao__card__valor {{ formatarValorHa(aptidaoSelecionada.historicoAgricola.areaSemHistoricoHa) }}

                        .modal-detalhe-aptidao__card(v-if='item.key === "pastagem"')
                            .modal-detalhe-aptidao__card__item
                                span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.areaSemPastagem') }}:
                                span.modal-detalhe-aptidao__card__valor {{ formatarValorHa(aptidaoSelecionada.pastagem.areaSemPastagemHa) }}

                        .modal-detalhe-aptidao__card(v-if='item.key === "declividade"')
                            .modal-detalhe-aptidao__card__item
                                span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.percentualDeclividade') }}:
                                span.modal-detalhe-aptidao__card__valor {{ formatarPercentual(aptidaoSelecionada.declividade.percentual) }}
                                
                        .modal-detalhe-aptidao__card(v-if='item.key === "janelaZarc"')
                            .modal-detalhe-aptidao__card__descricao
                                    span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.janelaZarc') }}:
                                    span.modal-detalhe-aptidao__card__valor(
                                        v-if='item.status === "SUCESSO"'
                                    ) {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.periodoDentroJanelaPermitida') }}
                                    span.modal-detalhe-aptidao__card__valor(
                                        v-else-if='item.status === "NAO_SE_APLICA"'
                                    ) {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.restricoesTag.NAO_SE_APLICA') }}
                                    span.modal-detalhe-aptidao__card__valor(
                                        v-else
                                    ) {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.periodoForaJanelaPermitida') }}
                            .modal-detalhe-aptidao__card_list(
                                v-for='cultura in culturasSelecionadas'
                            )
                                .modal-detalhe-aptidao__card__item
                                    span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.produto') }}:
                                    span.modal-detalhe-aptidao__card__valor {{ cultura.nome }}
                                .modal-detalhe-aptidao__card__item
                                    span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.inicioPlantio') }}:
                                    span.modal-detalhe-aptidao__card__valor {{ formatarDataString(cultura.dataInicioPlantio) }}
                                .modal-detalhe-aptidao__card__item
                                    span.modal-detalhe-aptidao__card__label {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fimPlantio') }}:
                                    span.modal-detalhe-aptidao__card__valor {{ formatarDataString(cultura.dataFimPlantio) }}

                        .modal-detalhe-aptidao__fonte(v-if='item.fonte')
                            .modal-detalhe-aptidao__fonte__toggle(
                                @click.stop='toggleFonte(item.key)'
                            )
                                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fonteDados') }}
                                i(:class='fonteAberta === item.key ? "el-icon-arrow-up" : "el-icon-arrow-down"')
                            .modal-detalhe-aptidao__fonte__content(v-if='fonteAberta === item.key')
                                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fonteDadosDataAtualizacao') }}: {{ formatarDataFonte(item.fonte.dataAtualizacao) }}
                                span {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fonteDadosNome') }}: {{ item.fonte.nome || '--' }}
                                span
                                    | {{ $t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.fonteDadosUrl') }}:
                                    | {{ ' ' }}
                                    a.modal-detalhe-aptidao__fonte__link(
                                        v-if='item.fonte.url',
                                        :href='item.fonte.url',
                                        target='_blank'
                                    ) {{ item.fonte.url }}
                                    template(v-else) --

        .modal-detalhe-aptidao__mapa
            mapa(
                :showStatesLayers='false',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaDetalheAptidao"',
                ref='mapa',
                :menuMaior='true',
                :doubleMapOnPage='true'
            )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';
import formatters from '@/utils/formatters';
import date from '@/utils/date';
export default {
    name: 'ModalDetalheAptidao',
    components: {
        Mapa
    },

    data() {
        return {
            mostrarModal: false,
            aptidaoSelecionada: null,
            culturasSelecionadas: null,
            collapseAtivo: '',
            fonteAberta: '',
            layersMaps: [],
            mapConfig: {
                controls: {
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: false,
                    bufferControl: false,
                    uploadFileControl: false,
                    ferramentasControl: true
                },
                historicoMonitoramento: false,
                inspecionar: false,
                diagnostico: false
            },
            statusMap: {
                SUCESSO: {
                    icon: 'el-icon-circle-check',
                    classe: 'modal-detalhe-aptidao__collapse-title__icone--sucesso'
                },
                ALERTA: {
                    icon: 'el-icon-circle-close',
                    classe: 'modal-detalhe-aptidao__collapse-title__icone--alerta'
                },
                ATENCAO: {
                    icon: 'el-icon-warning',
                    classe: 'modal-detalhe-aptidao__collapse-title__icone--atencao'
                },
                NAO_SE_APLICA: {
                    icon: 'el-icon-remove-outline',
                    classe: 'modal-detalhe-aptidao__collapse-title__icone--neutro'
                },
                NAO_ANALISADO: {
                    icon: 'el-icon-remove-outline',
                    classe: 'modal-detalhe-aptidao__collapse-title__icone--neutro'
                }
            }
        };
    },

    computed: {
        itensAnalise() {
            if (!this.aptidaoSelecionada) return [];

            const t = (key) =>
                this.$t(
                    `mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.${key}`
                );

            return [
                {
                    key: 'historicoAgricola',
                    label: t('historicoAgricola'),
                    status: this.aptidaoSelecionada.historicoAgricola?.status,
                    fonte: this.aptidaoSelecionada.historicoAgricola?.fonte
                },
                {
                    key: 'pastagem',
                    label: t('pastagem'),
                    status: this.aptidaoSelecionada.pastagem?.status,
                    fonte: this.aptidaoSelecionada.pastagem?.fonte
                },
                {
                    key: 'declividade',
                    label: t('declividade'),
                    status: this.aptidaoSelecionada.declividade?.status,
                    fonte: this.aptidaoSelecionada.declividade?.fonte
                },
                {
                    key: 'janelaZarc',
                    label: t('janelaZarc'),
                    status: this.aptidaoSelecionada.janelaZarc?.status,
                    fonte: this.aptidaoSelecionada.janelaZarc?.fonte
                }
            ];
        }
    },

    methods: {
        abrirModal(data, culturas) {
            this.aptidaoSelecionada = data;
            this.culturasSelecionadas = culturas;
            this.layersMaps = [];
            this.collapseAtivo = '';
            this.fonteAberta = '';
            this.mostrarModal = true;

            this.$nextTick(() => {
                if (data.gleba?.geometria) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('operacaoGleba'),
                        geoJson: data.gleba.geometria,
                        name: 'gleba'
                    });
                }
                if (data.gleba?.geometriaTerritorio) {
                    this.layersMaps.push({
                        style: getEstiloGeometria('operacaoTerritorio'),
                        geoJson: data.gleba.geometriaTerritorio,
                        name: 'territorio'
                    });
                }
            });
        },

        abrirCollapse(ref) {
            this.layersMaps = this.layersMaps.filter(lm => lm.name !== 'pastagem' && lm.name !== 'declividade' && lm.name !== 'historicoAgricola');

            if (ref === 'pastagem' && this.aptidaoSelecionada.pastagem?.geometrias) {
                this.aptidaoSelecionada.pastagem.geometrias.forEach(g => {
                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        geoJson: g,
                        name: 'pastagem'
                    });
                });
            }

            if (ref === 'declividade' && this.aptidaoSelecionada.declividade?.geometrias) {
                this.aptidaoSelecionada.declividade.geometrias.forEach(g => {
                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        geoJson: g,
                        name: 'declividade'
                    });
                });
            }
            
            if (ref === 'historicoAgricola' && this.aptidaoSelecionada.historicoAgricola?.geometrias) {
                this.aptidaoSelecionada.historicoAgricola.geometrias.forEach(g => {
                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        geoJson: g,
                        name: 'historicoAgricola'
                    });
                });
            }
            
        },

        fecharModal() {
            this.mostrarModal = false;
            this.aptidaoSelecionada = null;
            this.layersMaps = [];
            this.collapseAtivo = '';
            this.fonteAberta = '';
        },

        statusIcone(status) {
            const config = this.statusMap[status];
            if (!config) return '';
            return [config.icon, config.classe];
        },

        formatarValorHa(valor) {
            if (valor == null) return '--';
            return `${formatters.minFormatNumber(valor, 2, this.$i18n.locale)} ha`;
        },

        formatarPercentual(valor) {
            if (valor == null) return '--';
            return `${valor}%`;
        },

        toggleFonte(key) {
            this.fonteAberta = this.fonteAberta === key ? '' : key;
        },

        formatarDataFonte(data) {
            if (!data) return '--';
            return formatters.localDateToString(data) || '--';
        },

        formatarDataString(data) {
            if (!data) return '--';
            return date.formatStringDateUsingLocale(data) || '--';
        },

        formatarValorDeclividade(valor) {
            if (valor == null) return '--';
            return `${this.$t(`mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.maiorQue`)} ${valor}° (>${valor}°)`;
        }
    }
};
</script>

<style lang="scss">
.modal-detalhe-aptidao {
    .el-dialog__body {
        display: flex;
        padding: initial !important;
    }

    .el-dialog__header {
        padding: initial;
    }

    .modal-detalhe-aptidao__lista {
        display: flex;
        flex-direction: column;
        min-width: 575px;
        gap: 20px;
        max-height: 100vh;
        padding: 20px 10px 20px 20px;

        .modal-detalhe-aptidao__lista__header {
            .voltar {
                cursor: pointer;
                margin-right: 10px;
            }

            h2 {
                color: var(--primary-font-color);
            }
        }

        .modal-detalhe-aptidao__lista__content {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 90vh;
            overflow-y: auto;
        }
    }

    .modal-detalhe-aptidao__territorio {
        h3 {
            font-weight: bold;
            color: var(--primary-font-color);
        }
    }

    .modal-detalhe-aptidao__gleba-info {
        display: flex;
        gap: 40px;

        .modal-detalhe-aptidao__gleba-info__item {
            display: flex;
            flex-direction: column;
        }

        .modal-detalhe-aptidao__gleba-info__label {
            font-size: 12px;
            color: #8a8a8a;
            margin-bottom: 4px;
        }

        .modal-detalhe-aptidao__gleba-info__valor {
            font-weight: 600;
            color: var(--primary-font-color);
        }
    }

    .modal-detalhe-aptidao__collapse {
        border-top: none;

        .el-collapse-item__header {
            background-color: #fff;
            border-radius: $default-border-radius;
            padding: 0 15px;
            margin-bottom: 4px;
            border-bottom: none;
            height: 50px;
            line-height: 50px;
        }

        .el-collapse-item__wrap {
            border-bottom: none;
        }

        .el-collapse-item__content {
            padding: 10px 15px;
        }
    }

    .modal-detalhe-aptidao__collapse-title {
        display: flex;
        align-items: center;
        gap: 10px;

        .modal-detalhe-aptidao__collapse-title__icone {
            font-size: 20px;

            &--sucesso {
                color: #3d8c73;
            }

            &--alerta {
                color: #df675b;
            }

            &--atencao {
                color: #c7b239;
            }

            &--neutro {
                color: #5e5e5e;
            }
        }
    }

    .modal-detalhe-aptidao__status-texto {
        font-size: 13px;
        margin-bottom: 8px;

        .modal-detalhe-aptidao__status-texto__valor {
            font-weight: 600;
            margin-left: 4px;
        }

        &--sucesso .modal-detalhe-aptidao__status-texto__valor {
            color: #3d8c73;
        }

        &--alerta .modal-detalhe-aptidao__status-texto__valor {
            color: #df675b;
        }

        &--atencao .modal-detalhe-aptidao__status-texto__valor {
            color: #c7b239;
        }

        &--nao_se_aplica .modal-detalhe-aptidao__status-texto__valor,
        &--nao_analisado .modal-detalhe-aptidao__status-texto__valor {
            color: #5e5e5e;
        }
    }

    .modal-detalhe-aptidao__card {
        background-color: rgba(240, 240, 240, 0.5);
        border-radius: $default-border-radius;
        padding: 15px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .modal-detalhe-aptidao__card__item {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .modal-detalhe-aptidao__card__descricao {
            display: flex;
            gap: 6px;
            align-items: center;
        }

        .modal-detalhe-aptidao__card__label {
            font-weight: bold;
            font-size: 13px;
            color: var(--primary-font-color);
        }

        .modal-detalhe-aptidao__card__valor {
            font-size: 13px;
            color: var(--primary-font-color);
        }
    }

    .modal-detalhe-aptidao__fonte {
        margin-top: 10px;

        .modal-detalhe-aptidao__fonte__toggle {
            display: flex;
            align-items: center;
            gap: 6px;
            cursor: pointer;
            font-size: 13px;
            color: var(--primary-font-color);

            i {
                font-size: 12px;
            }
        }

        .modal-detalhe-aptidao__fonte__content {
            display: flex;
            flex-direction: column;
            gap: 4px;
            margin-top: 8px;
            font-size: 13px;
            color: #8a8a8a;
        }

        .modal-detalhe-aptidao__fonte__link {
            color: var(--primary);
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .modal-detalhe-aptidao__mapa {
        width: 100%;
        height: 100vh;
        border-radius: 0;
    }
}
</style>
